import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import styles from "./card2.module.css";

import badamMilk from "../../assets/images/data/istockphoto-1489742877-612x612.jpg";
import burger from "../../assets/images/data/89597.jpg";
import cholekulche from "../../assets/images/data/pindi-chole-kulche-roadside-choley-600nw-1527268631.webp";
import coldcoffee from "../../assets/images/data/coldcoffee.jpg";
import grillsandwich from "../../assets/images/data/grillsandwich.jpg";
import idli from "../../assets/images/data/idli.jpg";
import kachorialoosabzi from "../../assets/images/data/kachori-with-aloo-sabzi.jpg";
import lassi from "../../assets/images/data/lassi.webp";
import littichokha from "../../assets/images/data/littichokha.jpg";
import makhanakheer from "../../assets/images/data/makhanakheer.jpg";
import momos from "../../assets/images/data/momos.webp";
import mutterkachodi from "../../assets/images/data/mutterkachodi2.jpg";
import pasta from "../../assets/images/data/pasta.jpg";
import pavbhaji from "../../assets/images/data/pavbhaji.jpeg";
import poha from "../../assets/images/data/poha.webp";
import samosa from "../../assets/images/data/samosa.jpg";
import sattu from "../../assets/images/data/sattu.webp";
import springroll from "../../assets/images/data/springroll.jpg";
import vada from "../../assets/images/data/vada.jpg";
import vadapav from "../../assets/images/data/vadapav.jpg";
import oreoshake from "../../assets/images/2148603229.jpg";
import fruit from "../../assets/images/smoothie-8031132_640.jpg";
import chow from "../../assets/images/pexels-nadin-sh-78971847-24738507.jpg";
import roll from "../../assets/images/spring-rolls-8135469_640.jpg";

const images = [
  badamMilk, burger, cholekulche, coldcoffee, grillsandwich, idli,
  kachorialoosabzi, lassi, littichokha, makhanakheer, momos, mutterkachodi,
  pasta, pavbhaji, poha, samosa, sattu, springroll, vada, vadapav,oreoshake,fruit,chow,roll
];

export const Card2 = () => {
  const [index, setIndex] = useState(-1);

  return (
    <div>
      <div className={styles.grid}>
        {images.map((img, i) => (
          <div key={i} className={styles.gridItem} onClick={() => setIndex(i)}>
            <img src={img} alt={`food-${i}`} className={styles.image} />
          </div>
        ))}
      </div>

      <Lightbox
        slides={images.map((src) => ({ src }))}
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
      />
    </div>
  );
};
